import { fetchIndeedGraphQL } from 'shared/legacy/hooks/useBrowserExtension/indeed/utils';
import { findConversationsByJobSeekerKey } from './indeed.GQLOperations';
import { getConversationsIdBasedOnJobSeekerProps, IndeedCandidateConversationResponse } from './indeed.types';

export const getConversationsIdBasedOnJobSeeker = async ({
  indeedConfig,
  jobSeekerKey,
  tenantId,
  candidateId,
}: getConversationsIdBasedOnJobSeekerProps) => {
  try {
    const response: IndeedCandidateConversationResponse = await fetchIndeedGraphQL(
      findConversationsByJobSeekerKey(jobSeekerKey),
      indeedConfig,
    );
    const conversationsObject = response.data.findConversations.conversations;
    return conversationsObject.map((conversation) => conversation.id);
  } catch (err) {
    newrelic.addPageAction('IndeedSyncStep', {
      step: 'conversations_error',
      tenantId,
      candidateId,
      jobSeekerKey,
      error: String(err),
    });
    return [];
  }
};
